import { entityInboxColumns } from "./ChatPaginatedList";
import InboxList, { InboxListProps } from "./InboxList";

export default function EntityInboxList({ displayProps, ...otherProps }: InboxListProps) {
  return (
    <InboxList
      defaultValues={{
        isActiveParticipant: null,
        hasMessages: null,
      }}
      displayProps={{
        breadcrumbs: false,
        header: false,
        columns: entityInboxColumns,
        ...displayProps,
      }}
      {...otherProps}
    />
  );
}
